import { list } from "@mc/mc-legacy";
import QSignAdminApi from "../api/gen/qsign/QSignAdminApi";

export const SIGN_CONFIGURATION_LIST = "signConfigurationList";
export const FLOW_CONFIGURATION_LIST = "flowConfigurationList";

export function fetchSignConfigurationsIfNeeded(force = false) {
  return (dispatch, getState) => {
    dispatch(
      list.SimpleListActions.fetchIfNeeded(
        SIGN_CONFIGURATION_LIST,
        null,
        (parent, filter) => {
          return QSignAdminApi.findConfigurations();
        },
        force
      )
    );
  };
}

export function fetchFlowConfigurationsIfNeeded(force = false) {
    return (dispatch, getState) => {
        dispatch(
            list.SimpleListActions.fetchIfNeeded(
                FLOW_CONFIGURATION_LIST,
                null,
                (parent, filter) => {
                    return QSignAdminApi.findFlowConfigurations();
                },
                force
            )
        );
    };
}
